import { render, staticRenderFns } from "./events_list.vue?vue&type=template&id=7463b8ce&scoped=true&"
import script from "./events_list.vue?vue&type=script&lang=js&"
export * from "./events_list.vue?vue&type=script&lang=js&"
import style0 from "./events_list.vue?vue&type=style&index=0&id=7463b8ce&lang=scss&scoped=true&"
import style1 from "./events_list.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7463b8ce",
  null
  
)

export default component.exports